<template>
  <PModal
    :name="confirmationModalName"
    :title="options.title"
    :enable-close="!isLoading"
    :error-msg="confirmationModalErrorMsg"
    @before-open="onBeforeOpen"
    @closed="onClosed"
  >
    <div class="text-sm text-p-gray-40">
      <Component :is="options.body" v-if="isComponent(options.body)" />
      <p v-else>
        {{ options.body }}
      </p>
    </div>
    <template #footer>
      <div class="flex">
        <PBtn type="secondary" class="mr-6 w-1/2" :disabled="isLoading" @click="onCancel">
          {{ options.cancelButtonText }}
        </PBtn>
        <PBtn :type="confirmButtonType" class="w-1/2" :loading="isLoading" @click="onConfirm">
          {{ options.confirmButtonText }}
        </PBtn>
      </div>
    </template>
  </PModal>
</template>

<script setup lang="ts">
import { PBtn, PModal } from '@pequity/squirrel';
import { computed } from 'vue';
import { confirmationModalName } from '@/components/confirmation-modal/constants';
import { useConfirmationModal } from '@/composables/useConfirmationModal';
import { isComponent } from '@/utils/component';

defineOptions({
  name: 'ConfirmationModal',
});

// Data
const {
  confirmationModalOptions: options,
  confirmationModalErrorMsg,
  isLoading,
  onConfirm,
  onCancel,
  onBeforeOpen,
  onClosed,
} = useConfirmationModal();

// Computed
const confirmButtonType = computed(() => {
  if (options.value.type === 'danger') {
    return 'error';
  }

  return 'primary';
});
</script>
